import * as React from "react";
const SvgXIcon = (props) => /* @__PURE__ */ React.createElement("svg", { width: 10, height: 10, viewBox: "0 0 10 10", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M2 8L8 2.00001M2 2L8 7.99999", stroke: "#1D2329", strokeWidth: 1.5, strokeLinecap: "square" }));
export default SvgXIcon;
